var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgCamera = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 58,
    viewBox: "0 0 71 58",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#9FADC5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.784 48.012c-8.17-.003-14.79-6.626-14.79-14.796 0-.435.023-.865.062-1.296H0v17.54a7.636 7.636 0 007.633 7.634h55.332a7.633 7.633 0 007.633-7.633V31.923H57.52c.036.428.06.858.06 1.296-.002 8.17-6.625 14.793-14.795 14.793zM42.784 18.421c5.69 0 10.877 3.261 13.34 8.39h14.474V14.257a7.633 7.633 0 00-7.633-7.633h-2.888A2.501 2.501 0 0057.68 4.83h-2.903c-1.108 0-2.083.73-2.398 1.792h-5.14l-2.81-4.741h-3.97V0H30.044v1.882h-3.971v.054l-2.776 4.666h-5.075a2.506 2.506 0 00-2.41-1.78h-2.893c-1.108 0-2.084.728-2.398 1.79H7.633A7.636 7.636 0 000 14.256v12.566h29.443a14.795 14.795 0 0113.34-8.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.036 31.923a12.32 12.32 0 00-24.572 1.296c0 6.804 5.516 12.32 12.32 12.32s12.32-5.516 12.32-12.32c0-.433-.023-.865-.068-1.296zM42.784 43.546c-5.705 0-10.33-4.625-10.33-10.33a10.327 10.327 0 1120.656 0c0 5.704-4.623 10.328-10.326 10.33z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCamera, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/camera.5acf45d3.svg";
export { ForwardRef as ReactComponent };